<template>
    <b-modal size="xl" :no-close-on-backdrop="true"
             :hide-footer="true"
             @show="onShow"
             :static="true"
             :title="$t('item_add_new')" ref="innermodal">
        <div class="vld-parent" ref="i101" style="min-height: 50px;">
            <div class="form-inline" style="padding: 10px 0;">
                <div class="form-group">
                    <input type="text" class="form-control form-control-sm" placeholder="Code and name" v-model="query.Text" @keypress.enter="toList">
                </div>
            </div>
            <div class="out-border">
                <table class="table table-striped table-sm no-bor">
                    <thead>
                        <tr>
                            <th>{{ $t('no') }}</th>
                            <th>{{ $t('barcode') }}</th>
                            <th>{{ $t('name') }}</th>
                            <th>{{ $t('itemtype')}}</th>
                            <th>{{ $t('category') }}</th>
                            <th>{{ $t('uom') }}</th>
                            <th>{{ $t('model') }}</th>
                            <th class="text-right">{{ $t('qty') }}</th>
                            <th class="text-right">{{ $t('cost') }}</th>
                            <th class="text-right">{{ $t('price_sale') }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(ret, index) in records" :key="index">
                            <td>{{index+1}}</td>
                            <td>{{ ret.Num }}</td>
                            <td><a href="javascript:void(0)" @click="$emit('selected', ret)">{{ret.Name}}</a></td>
                            <td>{{ret.ProductTypeId == 1?'ទំនិញ':'សេវា' }}</td>
                            <td>{{ret.CategoryName}}</td>
                            <td>{{ret.UomName}}</td>
                            <td>{{ret.BrandName}}</td>
                            <td class="text-right">{{ret.OnHand}}</td>
                            <td class="text-right">{{$dollar(ret.Cost)}}</td>
                            <td class="text-right">{{$dollar(ret.Price)}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="box-page">
                <span>{{$t('total_record')}}: {{query.Total}}</span>
                <div class="pull-right">
                    <b-pagination size="sm" pills :total-rows="query.Total" :per-page="query.Limit" v-model="query.Page" :prev-text="$t('pre')" :next-text="$t('next')"
                                hide-goto-end-buttons
                                @change="paging($event)"/>
                </div>
            </div>
        </div>
    </b-modal>
</template>
<script>
export default {
    data(){
        return {
            query:{
                Page: 1,
                Total: 0,
                Limit: 20,
                Text: ''
            },
            records:[]
        }
    },
    methods: {
        onShow(){
            this.toList();
        },
        toList: function(){
            let loading = this.$loading.show({
                container: this.$refs.i101,
                loader: 'dots'
            });
            this.$api().post('item/list', this.query).then(res => {
                if(this.$isValid(res)){
                    this.records = res.data.Data;
                    this.query.Total = res.data.Total;
                }
            }).finally(function(){ loading.hide();});
        },
        paging(e){
            if(this.query.Page != e){
                this.query.Page = e;
                this.toList();
            }
        }
    }
}
</script>
<style scoped>
    .out-border{
        border: 1px solid #ddd !important;
        border-top: none;
    }
</style>